import type { InvitacionPublica } from '../../lib/equipoApi';

/**
 * Qué muestra `/unirme/:token` — spec 2026-09-11-invitaciones-equipo §3.1. Función pura para
 * que los siete estados se prueben sin DOM (vitest acá corre en `node`).
 */
export type EstadoInvitacion =
  | { tipo: 'cargando' }
  | { tipo: 'invalida'; motivo: 'inexistente' | 'vencido' | 'revocado' | 'equipo_lleno' }
  | { tipo: 'sin_sesion'; nombreMarca: string }
  | { tipo: 'sin_empresa'; nombreMarca: string }
  | { tipo: 'con_otra_empresa'; nombreMarca: string; planActualPago: boolean }
  | { tipo: 'ya_es_miembro' };

export function estadoDeInvitacion(p: {
  invitacion: InvitacionPublica | null;
  /** `null` mientras `getSession()` no respondió. */
  haySesion: boolean | null;
  cargandoCuenta: boolean;
  idCompanyActual: string | null;
  planActual: string;
}): EstadoInvitacion {
  if (!p.invitacion) return { tipo: 'cargando' };
  if (!p.invitacion.valido) return { tipo: 'invalida', motivo: p.invitacion.motivo };
  if (p.haySesion === null) return { tipo: 'cargando' };
  if (!p.haySesion) return { tipo: 'sin_sesion', nombreMarca: p.invitacion.nombreMarca };
  if (p.cargandoCuenta) return { tipo: 'cargando' };
  if (p.invitacion.yaEsMiembro) return { tipo: 'ya_es_miembro' };
  if (!p.idCompanyActual) return { tipo: 'sin_empresa', nombreMarca: p.invitacion.nombreMarca };
  return {
    tipo: 'con_otra_empresa',
    nombreMarca: p.invitacion.nombreMarca,
    planActualPago: p.planActual !== 'gratis',
  };
}
